import {
	Button,
	Card,
	Col,
	Input,
	Menu,
	Modal,
	Row,
	Select,
	Table,
	Typography,
	Pagination,
	Tooltip,
	Dropdown,
	Popover,
	DatePicker,
	Form,
	Grid,
} from 'antd'
import React, { useEffect, useState, useRef, useLayoutEffect, useInsertionEffect } from 'react'
import { CheckCircleOutlined, FileDoneOutlined } from '@ant-design/icons'
import openNotificationWithIcon from 'src/components/Notification'
const { Paragraph, Text } = Typography
const ButtonIcon = ({ type, title, setType, currentKey, icon }) => {
	return (
		<div
			className="btn-type-print"
			style={{
				cursor: 'pointer',
				backgroundColor: currentKey == type ? '#FFDEDE' : '#fff',
			}}
			onClick={() => {
				setType(type)
			}}
		>
			<div className="btn-type-print-icon">{icon}</div>
			<Text className="btn-type-print-txt">{title}</Text>
		</div>
	)
}
export default function ExportOrder({ open, onClose, exportFn, loadingExport = false }) {
	const [type, setType] = useState()
	return (
		<Modal
			title={
				<span style={{ fontSize: 20, color: '#181c32' }}>Vui lòng chọn hình thức export đơn</span>
			}
			open={open}
			footer={false}
			onCancel={() => onClose()}
		>
			<div>
				<ButtonIcon
					icon={<CheckCircleOutlined style={{ fontSize: 20, color: '#52c41a' }} />}
					title={'Export đơn đã chọn'}
					setType={setType}
					type={1}
					currentKey={type}
				/>
				<ButtonIcon
					icon={<FileDoneOutlined style={{ fontSize: 20, color: '#00a3ff' }} />}
					title={'Export toàn bộ vận đơn'}
					setType={setType}
					type={2}
					currentKey={type}
				/>

				<div className="btn-submit-print">
					<Button
						className="btn-submit-print-cancel"
						onClick={() => onClose()}
						style={{ height: 40, fontSize: 16 }}
					>
						Hủy
					</Button>
					<Button
						type="primary"
						onClick={() => {
							exportFn(type)
						}}
						style={{ height: 40, fontSize: 16 }}
						loading={loadingExport}
					>
						Xác nhận
					</Button>
				</div>
			</div>
		</Modal>
	)
}
